import React from 'react';

import { Link } from 'react-router-dom';

import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnName = {
  path: 'name',
  sort: 'name',
  link: '/shipping/companies/:_id',
  width: '100%',
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  render: (record) => (
    record.store?.name
    ? (
        <Link to={`/stores/${record.store._id}`}>
          {record.store.name}
        </Link>
      )
    : '-'
  ),
};

export const columnExportFormat = {
  align: 'right',
  title: 'Export Format',
  path: 'exportFormat',
}

export const [
  columnImport,
  columnExport,
] = [
  ['importColumns', 'Import Col #'],
  ['exportColumns', 'Export Col #'],
// eslint-disable-next-line arrow-body-style
].map(([path, title]) => {
  return {
    align: 'right',
    path,
    title,
    render: (record) => {
      const count = record[path]?.length || 0;
      return `${
        count > 0
        ? count
        : '-'
      }`;
    },
  }
});

export const ADMIN = [
  columnName,
  columnStore,
  columnImport,
  columnExport,
  columnExportFormat,
  columnCreatedAt,
  columnUpdatedAt,
];
